// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__pp-vY","indicator":"Badge_indicator__H8Vaf"};